<template>
	<div class="lv-table-cell-normal" :class="[{'lv-table-cell-normal-link':!head && data.col.link}]">
		<lv-scope-slot v-if="!!scopeSlotFunc" :scope-slot-func="scopeSlotFunc" :data="data"/>
		<lv-render-func v-else-if="!!renderFunc" :render-func="renderFunc" :data="data"/>
		<div v-else>
			<pl-tooltip-text v-if="head || data.col.tooltip" show-overflow-tooltip :content="p_text">
				<span>{{ p_text }}</span>
				<link-icon class="lv-table-cell-normal-tip" icon="icon-shuoming" v-if="head && data.col.tip" v-link-tooltip="data.col.tip"/>
			</pl-tooltip-text>
			<div v-else>
				<span>{{ p_text }}</span>
				<link-icon class="lv-table-cell-normal-tip" icon="icon-shuoming" v-if="head && data.col.tip" v-link-tooltip="data.col.tip"/>
			</div>
		</div>
	</div>
</template>

<script>
import LvScopeSlot from "../render/lv-scope-slot";
import LvRenderFunc from "../render/lv-render-func";
import PlTooltipText from "../tooltip/pl-tooltip-text";

export default {
	name: "lv-table-cell-normal",
	components: {PlTooltipText, LvRenderFunc, LvScopeSlot},
	props: {
		head: {type: Boolean},

		renderFunc: {type: Function},
		scopeSlotFunc: {type: Function},
		text: {},
		data: {},
	},
	data() {
		return {
			p_text: null,
		}
	},
	watch: {
		text: {
			immediate: true,
			async handler(val) {
				this.reset(val)
			}
		},
	},
	methods: {
		async reset(val) {
			if (!this.head) {
				const {formatter, dataType} = this.data.col
				if (!!formatter) {
					val = await formatter(val, this.data)
				} else if (!!dataType) {
					switch (dataType) {
						case 'tel':
							val = this.$lv.$utils.telFormat(val);
							break;
						case 'cny':
							val = this.$lv.$utils.cnyFormat(val);
							break;
						case 'money':
							val = this.$lv.$utils.moneyFormat(val);
							break;
						case 'int':
							val = this.$lv.$utils.intFormat(val);
							break;
						case 'percent':
							val = this.$lv.$utils.percentNumFormat(val);
							break;
					}
				}
			}
			this.p_text = val
		},
		async reCalc() {
			this.reset(this.text)
		},
	}
}
</script>

<style lang="scss">
@include themeify {
	.lv-table-cell-normal {
		width: 100%;
		overflow: hidden;
		white-space: nowrap;

		&.lv-table-cell-normal-link {
			color: $color-primary;
			cursor: pointer;
		}

		.lv-table-cell-normal-tip {
			color: #b3b6bf;
			padding: 0 3px;
			display: inline-block;
			box-sizing: content-box;
		}
	}
}
</style>
